const data = [{
  Year: 2002,
  Football: 13.72304418,
  "Men's basketball": 4.7381505,
  'Non-program specific': 15.3610088574,
  "Other men's sports": 7.55967708,
  "Other women's sports": 8.95958538,
  "Women's basketball": 2.548926,
}, {
  Year: 2003,
  Football: 14.8112874,
  "Men's basketball": 4.9779128,
  'Non-program specific': 25.3337451,
  "Other men's sports": 8.2752192,
  "Other women's sports": 10.4694279,
  "Women's basketball": 2.5033996,
}, {
  Year: 2004,
  Football: 16.2579237975,
  "Men's basketball": 5.47336515,
  'Non-program specific': 27.3964614,
  "Other men's sports": 9.2124615,
  "Other women's sports": 8.0030406555,
  "Women's basketball": 2.61724815,
}, {
  Year: 2005,
  Football: 22.36495597,
  "Men's basketball": 5.18003976,
  'Non-program specific': 29.97554672,
  "Other men's sports": 11.52689965,
  "Other women's sports": 13.63706386,
  "Women's basketball": 2.9256437,
}, {
  Year: 2006,
  Football: 19.38875092,
  "Men's basketball": 5.94619102,
  'Non-program specific': 27.79026096,
  "Other men's sports": 11.387068,
  "Other women's sports": 14.58575888,
  "Women's basketball": 3.63496364,
}, {
  Year: 2007,
  Football: 25.9684215,
  "Men's basketball": 6.1084485,
  'Non-program specific': 30.365781,
  "Other men's sports": 11.2298805,
  "Other women's sports": 15.0113535,
  "Women's basketball": 3.493728,
}, {
  Year: 2008,
  Football: 21.9762257,
  "Men's basketball": 6.36513306,
  'Non-program specific': 34.12339073,
  "Other men's sports": 11.34090386,
  "Other women's sports": 14.16621635,
  "Women's basketball": 3.94181931,
}, {
  Year: 2009,
  Football: 27.7477742,
  "Men's basketball": 6.89909855,
  'Non-program specific': 37.93175495,
  "Other men's sports": 11.9486844,
  "Other women's sports": 16.0220476,
  "Women's basketball": 4.9218278,
}, {
  Year: 2010,
  Football: 24.89283225,
  "Men's basketball": 8.3178524,
  'Non-program specific': 34.6784729291,
  "Other men's sports": 12.27156359,
  "Other women's sports": 15.29011913,
  "Women's basketball": 4.26294869,
}, {
  Year: 2011,
  Football: 24.01114992,
  "Men's basketball": 6.75146508,
  'Non-program specific': 30.10392168,
  "Other men's sports": 11.1694371,
  "Other women's sports": 14.20482714,
  "Women's basketball": 3.54460314,
}, {
  Year: 2012,
  Football: 30.004397112,
  "Men's basketball": 8.7128711576,
  'Non-program specific': 20.8023238768,
  "Other men's sports": 13.235223452,
  "Other women's sports": 15.7435354944,
  "Women's basketball": 4.0448676776,
}, {
  Year: 2013,
  Football: 37.68245624,
  "Men's basketball": 8.57978014,
  'Non-program specific': 40.09509944,
  "Other men's sports": 14.64585428,
  "Other women's sports": 15.61170752,
  "Women's basketball": 4.43360172,
}, {
  Year: 2014,
  Football: 43.38794539,
  "Men's basketball": 8.426182,
  'Non-program specific': 38.48683453,
  "Other men's sports": 12.55194971,
  "Other women's sports": 15.82237126,
  "Women's basketball": 3.92959521,
}, {
  Year: 2015,
  Football: 43.99709932,
  "Men's basketball": 9.26235369,
  'Non-program specific': 41.39398129,
  "Other men's sports": 13.17399666,
  "Other women's sports": 16.06523478,
  "Women's basketball": 4.17794239,
}, {
  Year: 2016,
  Football: 44.8382519,
  "Men's basketball": 12.8873693,
  'Non-program specific': 47.2556292,
  "Other men's sports": 13.0883181,
  "Other women's sports": 17.9113363,
  "Women's basketball": 4.4092295,
}, {
  Year: 2017,
  Football: 48.90086656,
  "Men's basketball": 10.45402624,
  'Non-program specific': 46.59568384,
  "Other men's sports": 13.23639296,
  "Other women's sports": 18.11432576,
  "Women's basketball": 4.70499328,
}, {
  Year: 2018,
  Football: 52.42918524,
  "Men's basketball": 9.1230396,
  'Non-program specific': 44.85259304,
  "Other men's sports": 13.33913508,
  "Other women's sports": 18.98234904,
  "Women's basketball": 4.85696592,
}, {
  Year: 2019,
  Football: 47.58860466,
  "Men's basketball": 8.58535838,
  'Non-program specific': 42.1418134,
  "Other men's sports": 14.48508318,
  "Other women's sports": 18.70307458,
  "Women's basketball": 4.93577352,
}, {
  Year: 2020,
  Football: 41.35466368,
  "Men's basketball": 9.48502786,
  'Non-program specific': 46.88679094,
  "Other men's sports": 11.24575573,
  "Other women's sports": 16.28999647,
  "Women's basketball": 4.52390202,
}, {
  Year: 2021,
  Football: 27.8363365,
  "Men's basketball": 6.80276865,
  'Non-program specific': 41.89553155,
  "Other men's sports": 10.44641715,
  "Other women's sports": 14.2819259,
  "Women's basketball": 3.3784884,
}, {
  Year: 2022,
  Football: 36.2609478,
  "Men's basketball": 8.0472042,
  'Non-program specific': 43.55189475,
  "Other men's sports": 12.57835215,
  "Other women's sports": 17.5678608,
  "Women's basketball": 4.5845562,
}, {
  Year: 2023,
  Football: 39.55818672,
  "Men's basketball": 9.3603003,
  'Non-program specific': 54.72078762,
  "Other men's sports": 13.76975622,
  "Other women's sports": 18.45350442,
  "Women's basketball": 5.15430888,
}];

export default data;
